import { CLIENT_ID } from "@/constants";
import Keycloak from "keycloak-js";

let keycloakInstance = null;

export function initKeycloak() {
  if (!keycloakInstance) {
    const kcOptions = {
      realm: process.env.VUE_APP_KEYCLOAK_REALM,
      url: process.env.VUE_APP_KEYCLOAK_URL,
      clientId: CLIENT_ID,
      "ssl-required": "external",
      resource: process.env.VUE_APP_KEYCLOAK_RESOURCE,
      "verify-token-audience": true,
      "use-resource-role-mappings": true,
      "confidential-port": 0,
      "policy-enforcer": {},
    };
    keycloakInstance = new Keycloak(kcOptions);
  }
  return keycloakInstance;
}

export function getKeycloak() {
  if (!keycloakInstance) {
    return null;
  }
  return keycloakInstance;
}
export function removeKeycloack() {
  keycloakInstance = null;
}
